import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    deleteDoc,
    query,
    setDoc,
    where,
    limit, orderBy
} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addShopifyBulkProductUpdates,
    addSingleShopifyBulkProductUpdate,
    updateShopifyBulkProductUpdates,
    updateSingleShopifyBulkProductUpdate,
    deleteSingleShopifyBulkProductUpdate,
    // deleteShopifyBulkProductUpdates,
    getSingleShopifyBulkProductUpdate,
    searchShopifyBulkProductUpdates,
    getAllPODShopifyBulkProductUpdates,
    prepareShopifyBulkProductUpdatesList
}

const collectionName = 'shopify-bulk-product-updates';
const collectionReference = collection(fireStoreDB, collectionName);

const addShopifyBulkProductUpdates = (shopifyBulkProductUpdates) => {
    return Promise.map(shopifyBulkProductUpdates, async shopifyBulkProductUpdate => {
        console.log('.');
        await addSingleShopifyBulkProductUpdate(shopifyBulkProductUpdate);
    });
}

const updateShopifyBulkProductUpdates = (shopifyBulkProductUpdates) => {
    return Promise.map(shopifyBulkProductUpdates, async shopifyBulkProductUpdate => {
        console.log('.');
        await updateSingleShopifyBulkProductUpdate(shopifyBulkProductUpdate);
    });
}

const addSingleShopifyBulkProductUpdate = (shopifyBulkProductUpdate) => {
    return addDoc(collectionReference, shopifyBulkProductUpdate);
}

const updateSingleShopifyBulkProductUpdate = (shopifyBulkProductUpdate) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkProductUpdate.id);
    return setDoc(documentReference, shopifyBulkProductUpdate);
}

export const deleteShopifyBulkProductUpdates = (shopifyBulkProductUpdates) => {
    return Promise.map(shopifyBulkProductUpdates, async shopifyBulkProductUpdate => {
        console.log('.');
        await deleteSingleShopifyBulkProductUpdate(shopifyBulkProductUpdate);
    });
}

const deleteSingleShopifyBulkProductUpdate = (shopifyBulkProductUpdate) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkProductUpdate.id);
    return deleteDoc(documentReference);
}

const getSingleShopifyBulkProductUpdate = (shopifyBulkProductUpdateId) => {
    const documentReference = doc(fireStoreDB, collectionName, shopifyBulkProductUpdateId);
    return getDoc(documentReference);
}

const searchShopifyBulkProductUpdates = async (searchCriteriaList, perPage = 10) => {
    let searchQuery = query(collectionReference);

    searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery,
        limit(perPage));

    const shopifyBulkProductUpdateResult = await getDocs(searchQuery);
    return prepareShopifyBulkProductUpdatesList(shopifyBulkProductUpdateResult);
}

const getAllPODShopifyBulkProductUpdates = async (podId) => {
    let searchQuery = query(collectionReference,
        where("podId", "==", podId));

    const shopifyBulkProductUpdateResult = await getDocs(searchQuery);
    return prepareShopifyBulkProductUpdatesList(shopifyBulkProductUpdateResult);
}

const prepareShopifyBulkProductUpdatesList = (shopifyBulkProductUpdateResult) => {
    const shopifyBulkProductUpdatesList = [];

    _.forEach(shopifyBulkProductUpdateResult.docs, shopifyBulkProductUpdateDoc => {
        shopifyBulkProductUpdatesList.push({
            ...shopifyBulkProductUpdateDoc.data(),
            id: shopifyBulkProductUpdateDoc.id
        });
    });

    return shopifyBulkProductUpdatesList;
}
